export default function AlgebraActivityWrapper({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}): React.ReactElement {
  const flexClassNames = 'flex flex-wrap justify-center items-center'
  const textClassNames = 'text-purple font-semibold text-md sm:text-lg'

  return <div className={`my-auto py-8 md:py-0 ${flexClassNames} ${textClassNames} ${className}`}>{children}</div>
}
